"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekdaysPicker = void 0;
const toggle_1 = __importDefault(require("@opsbase/lib-general/utils/toggle"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const range_1 = __importDefault(require("lodash/range"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = () => ({
    button: {
        width: 48,
        height: 38,
        borderRadius: 20,
        minWidth: 38,
        padding: 0,
    },
});
const WeekdaysPicker = (props) => {
    const { weekdays, multi = false, onChange } = props;
    const numDays = weekdays === null || weekdays === void 0 ? void 0 : weekdays.length;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleClickDayOfWeek = (0, useCallforward_1.default)(v => () => {
        onChange(multi ? (0, toggle_1.default)(weekdays, v) : [v]);
    }, [onChange, multi, weekdays]);
    return (react_1.default.createElement(Horizontal_1.default, { padding: true, gutter: true, centered: true }, (0, range_1.default)(7).map(n => {
        const isSelected = multi ? weekdays.indexOf(n) >= 0 : (weekdays === null || weekdays === void 0 ? void 0 : weekdays[0]) === n;
        return (react_1.default.createElement(Button_1.default, { key: 'day-button-' + n, color: isSelected ? lib_palette_1.default.secondary : lib_palette_1.default.White, bordered: true, noEvents: isSelected && numDays <= 1, classes: { root: myCss.button }, onClick: handleClickDayOfWeek(n), label: moment_timezone_1.default.weekdaysShort()[n] }));
    })));
};
exports.WeekdaysPicker = WeekdaysPicker;
exports.default = exports.WeekdaysPicker;
